// extracted by css-extract-rspack-plugin
export default {"cls1":"AppsMegaMenu-cls1_Kv8","cls2":"AppsMegaMenu-cls2_pbt AppsMegaMenu-cls1_Kv8"};